import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { Observable, Subject, concatMap, filter, lastValueFrom, take, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import {
  IItemToRequest,
  MyPurchaseForm,
  StoreDropdowns,
  UserInformation,
  FileInformation,
} from 'src/app/shared/models/app-models';
import SourcingStatusJSON from 'src/app/data/constants/SourcingStatus.json';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';
import { addCurrencyExchange } from 'src/app/core/store/CurrencyExchange.action';
import { DeletedItemVendorsState, deletedItemVendorsReducer } from 'src/app/core/store/DeletedItemVendors.reducer';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { environment } from 'src/environments/environment';
import { AttachmentComponent, AttachmentData } from 'src/app/modules/mypurchase-form/attachments/attachment.component';
export interface IitemRequestTable {
  index: number;
  itemId: number;
  displayItemNumber: number;
  PurchaseItemId: string | null;
  ItemDescription: string;
  TotalAmount: string;
  isDeleted: boolean;
  Strikethrough: boolean;
  amountMaintenance: string | null;
  estimatedAsset: string | null;
  projectCofunding: string | null;
  reasonDescription: string | null;
  spaceRequirement: string | null;
}
@Component({
  selector: 'app-capital-usage-req-summary',
  templateUrl: './capital-usage-req-summary.component.html',
  styleUrls: ['./capital-usage-req-summary.component.scss'],
  providers: [
    {
      provide: DatePipe,
    },
    {
      provide: DecimalPipe,
    },
  ],
})
export class CapitalUsageReqSummaryComponent {
  @Output() itemCost = new EventEmitter<string>();
  readonly permissionData$: Observable<any>
  @ViewChild('attachment') attachmentComponent!: AttachmentComponent;
  purchaseTypeMap = PurchaseTypeMap
  itemCostValue: string = "";
  @Input() isReadOnly: boolean = false;

  columns = [
    {
      columnDef: 'displayItemNumber',
      header: 'Item No.',
      cell: (element: IitemRequestTable) => `${element.displayItemNumber === 0 ? '-' : element.displayItemNumber}`,
    },
    {
      columnDef: 'ItemDescription',
      header: 'Item Description',
      cell: (element: IitemRequestTable) => `${element.ItemDescription}`,
    },
    {
      columnDef: 'TotalAmount',
      header: 'Item amount (SGD)',
      cell: (element: IitemRequestTable) => `${element.TotalAmount}`,
    },
    {
      columnDef: 'EstimatedAsset',
      header: 'Est. usage of asset.',
      cell: (element: IitemRequestTable) => `${element.estimatedAsset}`,
    },
    {
      columnDef: 'AmountMaintenance',
      header: 'Annual main. (SGD)',
      cell: (element: IitemRequestTable) => `${element.amountMaintenance}`,
    },
    {
      columnDef: 'SpaceRequirement',
      header: 'Need add. space?',
      cell: (element: IitemRequestTable) => `${element.spaceRequirement}`,
    },
    {
      columnDef: 'ProjectCofunding',
      header: 'Any project not co-fund?',
      cell: (element: IitemRequestTable) => `${element.projectCofunding}`,
    },
    {
      columnDef: 'Reasons',
      header: 'Reasons',
      cell: (element: IitemRequestTable) => `${element.reasonDescription}`,
    }
  ];
  tableData: IitemRequestTable[] = [];
  itemList: IItemToRequest[] = [];
  docStatus!: number | null;
  selectedCapitalReqUsage!: string | null;
  dataSource = new MatTableDataSource<IitemRequestTable>(this.tableData);
  selection = new SelectionModel<IitemRequestTable>(true, []);
  // filter out columns according to the user choice
  displayedColumns = this.columns.map(c => c.columnDef);
  destroy$: Subject<boolean> = new Subject<boolean>();
  pageSizeOptions: number[] = [5, 10, 20, 50];
  storeDropdowns?: StoreDropdowns;
  deactivatedItems: IItemToRequest[] = [];
  form?: MyPurchaseForm
  currencyExchangeRates: CurrencyExchange[] = [];
  ExchangeRateLock: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private datePipe: DatePipe,
    private store: Store<{ form: MyPurchaseForm; currency: CurrencyExchange[],
     }>,
    private decimalPipe: DecimalPipe,
    private backendService: BackendApiService,
    private permissionsService: PermissionsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.selectedCapitalReqUsage) this.selectedCapitalReqUsage = data.selectedCapitalReqUsage
    this.permissionData$ = permissionsService.getService().pipe(takeUntil(this.destroy$))
        this.store.select('currency').pipe(takeUntil(this.destroy$)).subscribe((currencies: CurrencyExchange[]) => {
      this.currencyExchangeRates = currencies
    })

    this.store
            .select('form')
            .pipe(takeUntil(this.destroy$))
            .subscribe((form: MyPurchaseForm) => {
              this.itemList = form.ItemList.concat(this.deactivatedItems);
              const CapitalReqUsageValues = this.selectedCapitalReqUsage?.split(',').map(Number);
              this.ExchangeRateLock = form.ExchangeRateLock;
              this.convertToTable(this.itemList).then(value => {
                this.tableData = value.filter((item) => CapitalReqUsageValues?.includes(item.displayItemNumber))
                this.dataSource = new MatTableDataSource<IitemRequestTable>(
                  this.tableData
                );
                this.dataSource.paginator = this.paginator;
              });
            });


   
  }
  async ngOnInit() {
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  formatDate(date: any): string {
    if (date) {
      return this.datePipe.transform(date, 'dd/MM/yyyy') ?? date;
    }
    return date;
  }

  async convertCurrencyToSGD(amount: number, currCode: string, exchangeRateCurrency:number) {
    let exchangeRate
      
      
    if (currCode == 'SGD') return amount
    let currEx = this.currencyExchangeRates.find(x => x.FromCurrency == currCode)
    if (!currEx) {
      const resp: CurrencyExchange = await lastValueFrom(this.backendService.getCurrencyExchange(currCode));
      currEx = resp
      this.store.dispatch(addCurrencyExchange({ currency: resp }))
    }
    if(this.ExchangeRateLock){
      exchangeRate = exchangeRateCurrency;
      }else if(this.docStatus === 2 || this.docStatus === 3 || this.docStatus === 6){
        exchangeRate = currEx!.Rate;
      }else{
        exchangeRate = exchangeRateCurrency;
    }
    return (amount * (exchangeRate / currEx.RatioForTheFromCurrencyUnits))
  }
  async convertToTable(itemList: IItemToRequest[]) {
    let tableTable: IitemRequestTable[] = [];
    let estimatedTotal: number = 0.0;
    let index = 1;
    for (const item of itemList) {
      let totalAmountInItemCurrency =
        ((item.ItemPrice.Quantity) * item.ItemPrice.UnitPrice) /
        item.ItemPrice.UnitsPerQuantity;
      //convert totalAmountInItemCurrencyToSGD
      if (!item.isDeleted && !item.Strikethrough) {
        let totalAmount = await this.convertCurrencyToSGD(totalAmountInItemCurrency, item.ItemPrice.Currency.value, item.ItemPrice.ExchangeRate)
        estimatedTotal += totalAmount;
      }
      let IsSupportingNonFundingProject:string  = item.AddItems.IsSupportingNonFundingProject ? 'Yes': 'No'
      let IsAdditionalSpaceRequired:string  = item.AddItems.IsAdditionalSpaceRequired ? 'Yes': 'No'
      let tableObj: IitemRequestTable = {
        index: index,
        itemId: item.AddItems.itemId,
        displayItemNumber: item.AddItems.displayItemNumber,
        PurchaseItemId: item.AddItems.PurchaseItemId?.toString() ?? null,
        ItemDescription: item.AddItems.ItemDescription ?? null,
        TotalAmount: this.decimalPipe.transform(totalAmountInItemCurrency, '1.2-2') ?? '0.00',
        isDeleted: item.isDeleted ? true : false,
        Strikethrough: item.Strikethrough,
        amountMaintenance: item.AddItems.AnnualMaintenanceCost ?? '-',
        estimatedAsset: item.AddItems.EstimatedUsageId?.Name ?? '-',
        projectCofunding: IsSupportingNonFundingProject  ?? 'No',
        reasonDescription: item.AddItems.SupportingInformation ?? '-',
        spaceRequirement: IsAdditionalSpaceRequired ?? 'No',

      };
      if ((!item.isDeleted && !item.Strikethrough) || this.docStatus != 3) {
        index += 1;
      }
      tableTable.push(tableObj);
    }
    return tableTable;
  }
}

